import { Linkedin, Mail, MessageCircle } from "lucide-react";
import { NAV, LINKS } from "./data";
import { Container, MaskText, Logo, scrollToId } from "./primitives";

export const Footer = () => (
  <footer className="relative overflow-hidden bg-[#060B19] pt-20 text-white" data-testid="site-footer">
    <Container>
      <div className="grid gap-12 border-b border-white/10 pb-14 md:grid-cols-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <Logo className="h-10 w-10" />
            <span className="font-display text-lg font-bold leading-tight">Maicon Roberto</span>
          </div>
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-300">Consultoria em estratégia, marketing e vendas para empresas que querem crescer com direção.</p>
        </div>
        <div className="md:col-span-3">
          <div className="font-mono-x text-xs uppercase tracking-[0.2em] text-slate-400">Navegação</div>
          <ul className="mt-5 space-y-3">
            {NAV.map((n) => (
              <li key={n.id}><button onClick={() => scrollToId(n.id)} className="text-sm text-slate-300 transition-colors hover:text-[#CCFF00]" data-testid={`footer-link-${n.id}`}>{n.label}</button></li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-4">
          <div className="font-mono-x text-xs uppercase tracking-[0.2em] text-slate-400">Canais</div>
          <div className="mt-5 flex gap-3">
            {[[LINKS.linkedin, Linkedin, "footer-linkedin-link"], [LINKS.whatsapp, MessageCircle, "footer-whatsapp-link"], [LINKS.email, Mail, "footer-email-link"]].map(([href, Icon, id]) => (
              <a key={id} href={href} data-testid={id} className="grid h-12 w-12 place-items-center rounded-full border border-white/15 transition-[background-color,color,transform] duration-300 hover:-translate-y-1 hover:bg-[#CCFF00] hover:text-[#060B19]">
                <Icon size={18} />
              </a>
            ))}
          </div>
        </div>
      </div>
      <MaskText className="font-display py-12 text-[13vw] font-extrabold leading-[0.88] tracking-[-0.05em] lg:text-[9.5vw]"
        lines={["Estratégia. Marketing.", <span className="text-[#CCFF00]">Vendas. Crescimento.</span>]} />
      <div className="flex flex-col justify-between gap-3 border-t border-white/10 py-6 text-xs text-slate-400 sm:flex-row">
        <span>© {new Date().getFullYear()} Maicon Roberto. Todos os direitos reservados.</span>
        <span>Política de Privacidade · Termos de Uso</span>
      </div>
    </Container>
  </footer>
);
